import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const StyledTab = styled.li`
  align-items: center;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  opacity: ${({ isActive }) => (isActive ? '1' : '0.15')};
  padding-bottom: 32px;
  position: relative;
  text-align: center;
  transition: opacity 0.4s ease;
  width: 100%;

  ${({ theme }) => theme.media.desktop} {
    margin-bottom: 0px;
    width: 33.333333%;
  }
`

const StyledTitle = styled.h4`
  color: ${({ theme }) => theme.colors.titleFontColor};
  font-size: 1em;
  font-weight: 500;
  line-height: 1.6;
  margin-bottom: 8px;
`

const StyledSubtitle = styled.p`
  color: ${({ theme }) => theme.colors.greyParagraphColor};
  display: inline-block;
  font-size: 0.875em;
  line-height: 1.71;
  padding: 0px 5%;

  ${({ theme }) => theme.media.desktop} {
    padding: 0;
  }
`

const StyledWrapper = styled.div`
  margin-bottom: 0px;
`

const StyledTimeIndicator = styled.span.attrs(({ counter, isActive }) => ({
  style: {
    width: isActive ? counter + '%' : '',
    display: isActive ? 'block' : 'none',
  },
}))`
  background-color: ${({ theme }) => theme.colors.red};
  bottom: 0;
  height: 2px;
  left: 0;
  position: absolute;
  width: 100%;
`

const Tab = props => {
  const { title, subtitle } = props.data
  const standarizedSubtitle = subtitle.hasOwnProperty('subtitle')
    ? subtitle.subtitle
    : subtitle

  return (
    <StyledTab onClick={() => props.onClick()} isActive={props.isActive}>
      <StyledWrapper>
        <StyledTitle>{title}</StyledTitle>
        <StyledSubtitle>{standarizedSubtitle}</StyledSubtitle>
        <StyledTimeIndicator
          isActive={props.isActive}
          counter={props.counter}
        />
      </StyledWrapper>
    </StyledTab>
  )
}

Tab.propTypes = {
  data: PropTypes.object.isRequired,
}
export default Tab
